import React, { Component } from 'react';
import axios from 'axios';
import Breadcrumb from  '../../../components/Layout/Breadcrumb';
import { connect } from 'react-redux';
import {FaHistory, FaSearch} from "react-icons/fa";
import { Row, Col, Card, Table } from 'reactstrap';
import { Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import ListLogRowComponent from '../../../components/Admin/logs/ListLogRowComponent';
import PaginateComponent from  '../../../components/PaginateComponent';

class ListLogPage extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			listLog: [],
			perPage: 0,
			totalPage: 0,
			currentPage: 0,
			error: false,
			messageError: '',
			isNotification: '',
			textNotification: '',
			isSpinner: false,
			actions: [],
            qtt: 30,
            action: '',
            email: '',
            checkEmail: false,
            listUser: {},
            userId: 0,
            searchUser: '',
            service: ''
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.getListLog();
		this.setState({
			isNotification: this.props.isNotification,
			textNotification: this.props.textNotification,
		})
		if ( this.props.isNotification ) {
			this.props.notification({
				isNotification: false,
				textNotification: ''
			});
		}
	}

	getListLog = () => {
		this.setState({
			isLoading: true
		});

		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};
        let data = "?qtt=" + this.state.qtt + "&service=" + this.state.service + "&action=" + this.state.action + "&userId=" + this.state.userId;
        // console.log(process.env.REACT_APP_API_URL + '/api/admin/log/activity-log' + data)
        axios.get( process.env.REACT_APP_API_URL + '/api/admin/log/activity-log' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
		.then( (ref) => {
			// console.log(ref.data);
			this.setState({
				isLoading: false,
				error: false,
				messageError: '',
			});
			if ( ref.data.error === 0 ) {
				this.setState({
					listLog: ref.data.content.data,
					actions: ref.data.content.actions,
					rq_table: ref.data.content.filters,
					perPage: ref.data.content.perPage,
                    totalPage: ref.data.content.total,
                    currentPage: ref.data.content.current_page,
				})
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
	}

    listLogRow = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={12}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        } else {
            if ( this.state.listLog.length ) {
                return (
                    this.state.listLog.map( (log, key) => {
                        return (
                            <ListLogRowComponent
	                            key={key}
	                            log={log}
                            />
                        )
                    })
                );
            } else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="12">
                            Không có dữ liệu!
                        </td>
                    </tr>
                );
            }
        }
    }

	checkNotification = () => {
		if ( this.state.isNotification ) {
			return (
				<Alert color="success">{ this.state.textNotification } </Alert>
				);
		}
	}

	change = (event) => {
		this.setState(
			{
                [event.target.name] : event.target.type === 'checkbox' ? event.target.checked : event.target.value
			},
			() => this.getListLog()
		)
	}

    search = (event) => {
	    this.setState(
	    	{
                [event.target.name] : event.target.type === 'checkbox' ? event.target.checked : event.target.value
		    }
	    )
    }

    submitSearch = (event) => {
        if(event.key === 'Enter') {
        	this.setState(
				{
                    [event.target.name] : event.target.type === 'checkbox' ? event.target.checked : event.target.value
				},
				() => this.getListLog()
			)
        }
    }

    btnSearch = () => {
        this.setState(
			{
				currentPage: 0,
				rq_table: {
			        ...this.state.rq_table,
					page: 0
			    }
			},
			() => this.getListLog()
		)
    }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
        this.setState({
            isLoading: true
        });

        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let data = "?qtt=" + this.state.qtt + "&q=" + this.state.service + "&action=" + this.state.action
            + "&userId=" + this.state.userId + "&page=" + page;

        let config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization' : this.props.token,
                'dataAgency' : JSON.stringify(dataAuth)
            },
        }

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/log/activity-log' + data, config)
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    isLoading: false,
                    error: false,
                    messageError: '',
                });
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listLog: ref.data.content.data,
                        actions: ref.data.content.actions,
                        rq_table: ref.data.content.filters,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                        })
                    }
                }
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isLoading: false
                });
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu thất bại',
                })
            })
    }

    changeInput = (event) => {
        this.setState({
            [event.target.name] : event.target.type === 'checkbox' ? event.target.checked : event.target.value
        })
    }

    submitSearchUser = (event) => {
        if(event.key === 'Enter') {

            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };

            axios.get( process.env.REACT_APP_API_URL + '/api/admin/vps/searchUser?searchUser=' + this.state.searchUser,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    if ( ref.data.error === 0 ) {
                        this.setState({
                            listUser: ref.data.content,
                        })
                    } else {
                        if ( ref.data.error > 9000 ) {
                            this.props.logOut();
                        }
                        else {
                            this.setState({
                                errorForm: true,
                                messageForm: ref.data.message,
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( () => {
                    this.setState({
                        errorForm: true,
                        messageForm: 'Lấy dữ liệu thất bại',
                    })
                })
        }
    }

    loadSearchUser = () => {
        if ( this.state.listUser.length ) {
            return (
                <ul>
                    {
                        this.state.listUser.map( (user, key) => (
                            <li className={ (user.id === this.state.user_id ? "active" : "") + "choose-user" }
                                key={key}
                                onClick={ () => this.choosseUser( user ) }
                            >
                                { user.name }
                            </li>
                        ))
                    }
                </ul>
            );
        }
        else {
            return (
                <ul>
                    <li className="choose-user text-danger">Khách hàng không tồn tại</li>
                </ul>
            );
        }
    }

    choosseUser = async (user) => {
        await this.setState({
            userId: user.id,
            listUser: {},
            searchUser: user.name + ' - ' + user.email
        })
        await this.getListLog();
    }

	render() {
		return (
			<>
                <Breadcrumb title={"Activity Log"} page={"Activity Log"} icon={<FaHistory className="breadcrumb-icon" />} />
                <div className="row" style={{ marginTop: 20 }}>
                    <div className="col-md-12">
                        {
                            this.state.error ? (
                                <Alert color="danger">
                                    <div className='text-center'>
                                        { this.state.messageError }
                                    </div>
                                </Alert>
                            ) : (
                                <></>
                            )
                        }
                        {
                            this.checkNotification()
                        }
                    </div>
                </div>
                <Card body>
                	<Row>
                		<Col md={12} className="d-md-flex mb-0">
                			<select className="form-control select2 form-control-sm m-1" name='qtt'
                                    onChange={ this.change } id="per_page"
                                    defaultValue={this.state.qtt} style={{ width:'75px' }}
                            >
			                    <option value="10">10</option>
			                    <option value="20">20</option>
			                    <option value="30">30</option>
			                    <option value="50">50</option>
			                    <option value="100">100</option>
			                </select>
			                <label className="per_page ml-2 mt-2" htmlFor="per_page">Hiển thị mỗi trang</label>
                		</Col>
                		<Col md={12} className="mb-3">
                			<div className="float-md-right d-sm-flex">
                                <div className="search-user m-1">
                                    <input type="text" id="user" className="form-control form-control-sm"
                                           placeholder="Tìm kiếm khách hàng"
                                           onChange={ this.changeInput }
                                           name="searchUser"
                                           defaultValue={ this.state.searchUser }
                                           onKeyPress={ this.submitSearchUser }
                                    />
                                    {
                                        this.state.listUser.length ? (
                                            <div className="list-search-user">
                                                {
                                                    this.loadSearchUser()
                                                }
                                            </div>
                                        ) : (
                                            <></>
                                        )
                                    }
                                </div>
				                <select className="form-control select2 form-control-sm m-1" name="action"
                                        onChange={ this.change } defaultValue={ this.state.action }
                                        style={{ width:'210px' }}
                                >
				                    <option value="">Tất cả hành động</option>

				                    {
				                    	Object.entries(this.state.actions)
									  	.map(
									   		([key, action]) => (<option key={key} value={key}>{action}</option>)
									  	)
									}
				                </select>
                                <div className="form-group m-1">
                                    <div className="input-group">
                                        <input type="text" name="service" className="form-control form-control-sm"
                                               placeholder="Tìm kiếm dịch vụ" id="search"
                                               onChange={ this.changeInput }
                                               onKeyPress={ this.submitSearch }
                                        />
                                        <div className="input-group-append">
                                            <button type="button" className="btn btn-sm btn-danger" onClick={ () => this.btnSearch() }>
                                                <FaSearch  />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                		</Col>
                		<Col sm={12} className="table-responsive">
		                    <Table className="table table-sm table-bordered table-hover rounded">
		                        <thead className="primary">
		                            <tr>
		                                <th width="20%">Thời gian</th>
		                                <th className={'text-center'} width="20%">Người dùng</th>
		                                <th className={'text-center'} width="40%">Ghi chú</th>
		                                <th className={'text-center'} width="20%">Dịch vụ</th>
		                            </tr>
		                        </thead>
		                        <tbody>
		                            { this.listLogRow() } 
		                        </tbody>
		                    </Table>
		                    { this.paginate() }
		                </Col>
                	</Row>
                </Card>
            </>	
		);
	}
}



const mapStateToProps = (state) => {
	return {
		token: state.login.token,
		isNotification: state.adminMain.isNotification,
		textNotification: state.adminMain.textNotification,
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		logOut: () => {
			dispatch(({ type : 'logOut', page: 'AdminListLog' }))
		},
		notification: (item) => {
			dispatch(({ type : 'notification', item }))
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ListLogPage);